import Utils from 'live/lib/utils'
import { responseHandlerGenerator, errorHandlerGenerator } from '../utils'

const SERVICE_URL_PREFIX = '/services/plugin-mongodb'

function makeURL(qualifier, suffix) {
    let url = SERVICE_URL_PREFIX

    while (url.indexOf('/') === url.length - 1) url = url.substring(0, url.length - 2)

    if (typeof qualifier != 'undefined' && qualifier.length > 0) url += '/' + qualifier

    url += suffix

    return encodeURI(url)
}

const api = {
    getQueries: (qualifier, signal, onSuccess, onError) => {
        const url = makeURL(qualifier, '/queries')

        fetch(url, { signal: signal })
            .then(responseHandlerGenerator(onSuccess, onError, true))
            .catch(errorHandlerGenerator(url))
    },

    explainQuery: (qualifier, queryInfo, signal, onSuccess, onError) => {
        const url = makeURL(qualifier, '/explain')

        fetch(url, {
            method: 'POST',
            signal: signal,
            body: JSON.stringify(queryInfo),
            headers: Utils.fetchDefaults.headers,
            credentials: Utils.fetchDefaults.credentials
        })
            .then(responseHandlerGenerator(onSuccess, onError, true))
            .catch(errorHandlerGenerator(url))
    }
}

export default api
